import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

const styles = `
  @keyframes fadeIn {
    0% { opacity: 0; transform: translateY(20px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  .notfound-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 20px;
    background: linear-gradient(to bottom right, #ffffff, #f1f5f9, #dbeafe);
  }
  .notfound-card {
    background-color: #ffffff;
    padding: 40px;
    max-width: 500px;
    width: 100%;
    text-align: center;
    border: 1px solid #bfdbfe;
    border-radius: 20px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    animation: fadeIn 0.6s ease-out forwards;
  }
  .notfound-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }
  .notfound-title {
    font-size: 2rem;
    font-weight: bold;
    color: #1e40af;
    margin-bottom: 10px;
  }
  .notfound-message {
    font-size: 1rem;
    color: #475569;
    margin-bottom: 30px;
  }
  .notfound-button {
    display: inline-block;
    background-color: #2563eb;
    color: white;
    padding: 10px 24px;
    font-size: 1rem;
    font-weight: 500;
    text-decoration: none;
    border-radius: 8px;
    transition: background-color 0.3s ease;
  }
  .notfound-button:hover {
    background-color: #1d4ed8;
  }
`;

const NotFound = () => {
  return (
    <>
      <style>{styles}</style>
      <div className="notfound-wrapper">
        <div className="notfound-card">
          <div className="notfound-icon-wrapper">
            <AlertTriangle size={80} strokeWidth={1.5} color="#facc15" />
          </div>
          <h1 className="notfound-title">404 - Page Not Found</h1>
          <p className="notfound-message">
            Oops! The page you’re looking for doesn’t exist or was moved.
          </p>
          <Link to="/login" className="notfound-button">
            Go to Login
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
